/**
 * Vendor Import — non-editable locked-mappings table.
 *
 * Renders the "Mapped to core fields" section for one entity type: a bordered
 * 3-column Table of LockedReviewRows. Extracted from MappingReviewStep so it
 * can be reused by both MappingReviewStep and MappingReviewSection.
 */

import { Table } from '@/lib/base/table/table';

import { LockedReviewRow } from './LockedReviewRow';
import { reviewRowKey } from './reviewGrouping';
import type { CoreMapping } from './types';

export function LockedMappingsTable({
  entityType,
  entityLabel,
  mappings,
}: {
  entityType: string;
  entityLabel: string;
  mappings: CoreMapping[];
}) {
  return (
    <div className='flex flex-col gap-2'>
      <p className='text-xs font-medium text-tertiary uppercase tracking-wide'>
        Mapped to core fields
      </p>
      <div className='overflow-x-auto rounded-lg border border-[var(--color-border-secondary)]'>
        <Table aria-label={`${entityLabel} core property mappings`} size='sm'>
          <Table.Header>
            <Table.Head label='Field' isRowHeader />
            <Table.Head label='Mapping' />
            <Table.Head label='Status' />
          </Table.Header>
          <Table.Body>
            {mappings.map(mapping => {
              const rowKey = reviewRowKey(entityType, mapping.source_property);
              return (
                <LockedReviewRow
                  key={rowKey}
                  rowKey={rowKey}
                  mapping={mapping}
                />
              );
            })}
          </Table.Body>
        </Table>
      </div>
    </div>
  );
}
